import { z } from "zod";

export const ratingResolver = z.number().nullable();
export type RatingModel = z.infer<typeof ratingResolver>;
